import styled from 'styled-components';

const Field = styled.div`
  display: flex;
  margin-bottom: 1rem;
  align-items: top;
`;

export default Field;
